import {createApp} from 'vue';
import Notifications from '@kyvg/vue3-notification';
import notifyMixin from '@/mixins/notify';

export default function registerNotifications(app) {
  app.use(Notifications);
  app.mixin(notifyMixin);
  const globalMixin = {
    computed: {
      $providerTenant() {
        return this.$store.state.providerTenant;
      },
      $providerTenantVal() {
        return this.$store.state.providerTenantVal;
      },
      $providerUrl() {
        return this.$store.state.providerUrl;
      },
      $collection() {
        return this.$store.state.collection;
      },
      $isDark() {
        const theme = window.localStorage.getItem("idrive-theme");
        if (!theme || theme === 'default') return false;
        return theme === 'dark';
      }
    }
  };
  app.mixin(globalMixin);
}